"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetlistSource = exports.NetlistGateState = exports.NetlistClearanceOutcome = void 0;
var NetlistClearanceOutcome;
(function (NetlistClearanceOutcome) {
    NetlistClearanceOutcome["Validated"] = "validated";
    NetlistClearanceOutcome["ErrorsAccepted"] = "errors_accepted";
    NetlistClearanceOutcome["NoGenerator"] = "no_generator";
})(NetlistClearanceOutcome || (exports.NetlistClearanceOutcome = NetlistClearanceOutcome = {}));
var NetlistGateState;
(function (NetlistGateState) {
    NetlistGateState["NotArmed"] = "not_armed";
    NetlistGateState["Pending"] = "pending";
    NetlistGateState["Cleared"] = "cleared";
})(NetlistGateState || (exports.NetlistGateState = NetlistGateState = {}));
var NetlistSource;
(function (NetlistSource) {
    NetlistSource["Generated"] = "generated";
    NetlistSource["Uploaded"] = "uploaded";
})(NetlistSource || (exports.NetlistSource = NetlistSource = {}));
//# sourceMappingURL=netlist-gate.js.map